import { useModal } from '../useModal'
import { BUTTONS, TEXT, TITLE } from '../../components/modals/universalModal'
import { errorConfig } from '../../constants/copyright'

/**
 * Хук для показа информационных модальных окон об ошибке для пользователей
 * Если ошибка есть в errorConfig, выводим ее, если нет, выводим errorConfig.defaultError
 */
export const useErrorModalHandler = () => {
  const { addModal } = useModal()

  return (data = {}) => {
    const message = data?.message?.[0]?.toLowerCase() || ''

    const key = Object.keys(errorConfig).find((key) => message.includes(key)) ?? null

    const error = key ? errorConfig[key] : errorConfig.defaultError

    if (error) {
      addModal({
        type: 'universalModal',
        props: {
          modalProps: { wrapper: { isFullPage: false }, modifier: 'noFullNoScroll' },
          components: [
            {
              list: [
                {
                  type: TITLE,
                  props: {
                    modifier: 'padding-no',
                    value: error.title,
                  },
                },
                {
                  type: TEXT,
                  props: {
                    value: error.text,
                  },
                },
                {
                  type: BUTTONS,
                  props: {
                    buttons: [
                      {
                        text: error.button,
                        timeout: 1000,
                        modalData: { action: 'close', data: { type: 'current' } },
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
      })
    }
  }
}
